import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ApiService } from '../api.service';
import { MatCardModule } from '@angular/material/card';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { SynchronizerService } from '../synchronizer.service';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { UserUpdateObject } from '@models/UserUpdateObject';
import { MarkedPipe } from '../marked.pipe';
import { CommonModule } from '@angular/common';
import { CommonTasksService } from '../common-tasks.service';

@Component({
  selector: 'app-user-settings',
  imports: [
    CommonModule,
    MatCardModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatListModule,
    RouterModule,
    MarkedPipe
  ],
  templateUrl: './user-settings.component.html',
  styleUrl: './user-settings.component.scss'
})
export class UserSettingsComponent {
  formGroup: FormGroup = new FormGroup({});

  constructor(
    private api: ApiService,
    public syncService: SynchronizerService,
    private fb: FormBuilder,
    public commonTasks: CommonTasksService,
  ) {
    this.formGroup = this.fb.group({
      user_id: '',
      user_desciption: '',
    });

    this.syncService.user$.subscribe((user) => {
      if (user) {
        // Initialize the form group with the FormBuilder service
        this.formGroup.patchValue({
          user_id: user.user_id,
          user_desciption: user.description,
        });
      }
    });

  }

  async onSave() {
    const userId = this.formGroup.get('user_id')?.value;
    const userDescription = this.formGroup.get('user_desciption')?.value;

    const uuo: UserUpdateObject = {
      user_id: userId,
      user_description: userDescription,
    }

    const result = await this.api.updateUser(uuo);
    if (result) {
      this.commonTasks.showSnackbarMessage('User profile updated successfully.');
    } else {
      this.commonTasks.showSnackbarMessage('There was a problem saving the user profile.');
    }
  }

}
